import { FC } from 'react'
import { isUndefined } from 'lodash'

import { FilterButton, Icon, RadioSelect, useDropdown } from '@revolut-internal/ui-kit'

import { MIN_VALUES_FOR_SEARCHABLE } from './consts'
import { FilterPropsSingle } from './types'

export const SelectFilter: FC<FilterPropsSingle> = ({
  label,
  value,
  options = [],
  loadingState,
  isSearchable,
  onChange,
}) => {
  const dropdown = useDropdown()
  const dropdownTargetProps = dropdown.getTargetProps<HTMLElement>()
  const selectedOption = options.find(option => option.value === value)

  return (
    <>
      <FilterButton
        {...dropdown.getAnchorProps()}
        aria-label={label}
        aria-haspopup="listbox"
        aria-expanded={dropdown.state}
        useEndIcon={
          <Icon
            name={dropdownTargetProps.open ? 'ChevronUp' : 'ChevronDown'}
            size={20}
            color="grey-tone-50"
          />
        }
      >
        {selectedOption?.label ?? label}
      </FilterButton>

      <RadioSelect
        {...dropdownTargetProps}
        // RadioSelect doesn't reset its internal state when no value is provided (onClear)
        // and keeps highlighting last selected value
        key={value ? 'filled' : 'empty'}
        options={options}
        value={value}
        labelList={label}
        indicatorStyle="highlight"
        loadingState={loadingState}
        searchable={
          !isUndefined(isSearchable)
            ? isSearchable
            : options.length >= MIN_VALUES_FOR_SEARCHABLE
        }
        autoClose
        onChange={onChange}
      />
    </>
  )
}
